import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {HelperService} from '../helpers';
import {StorageService} from '../storage.service';
import {Router} from '@angular/router';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public loginForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required)
  });

  public resetPasswordForm = new FormGroup({
    username: new FormControl('', Validators.required),
  });

  public loginError = null;
  public loginInProgress = false;

  public resetError = null;
  public resetProgress = false;
  public resetSuccess = false;

  public forgottenPasswordVisible = false;

  public premiumFlyerUrl = environment.premiumFlyerUrl

  constructor(
    private http: HttpClient,
    private helper: HelperService,
    private storage: StorageService,
    private router: Router,
  ) {
  }

  ngOnInit() {
  }

  login(form) {
    if (form.valid) {
      this.loginInProgress = true;
      this.http.post(this.helper.getAuthUrl(), {
        username: form.controls.username.value,
        password: form.controls.password.value,
      }).subscribe((response: any) => {
        this.loginInProgress = false;
        if (response.token && response.user_roles.indexOf('zdravnik') > -1) {
          this.loginError = null;
          this.storage.setItem('premium|auth', response);
          this.router.navigate(['/']);
        }
      }, (error) => {
        this.loginInProgress = false;
        this.loginError = 'Pri prijavi je prišlo do napake! Ste vpisali pravilno uporabniško ime in geslo?';
      });
    }
  }

  showForgottenPassword(state = true) {
    this.resetError = null;
    this.resetSuccess = false;
    this.resetProgress = false;
    this.forgottenPasswordVisible = state;
  }

  reset(form) {
    this.resetError = null;
    this.resetSuccess = false;

    if (form.invalid) {
      this.resetError = 'Vnesite vaš e-naslov';
      return;
    }

    this.resetProgress = true;
    this.http.post(this.helper.getResetUrl() + '/reset', {
      user: form.controls.username.value,
    }).subscribe((response: any) => {
      this.resetProgress = false;
      if (response.success === false) {
        switch (response.data.error) {
          case 'Invalid email':
          case 'Email missing':
          case 'Not possible fot this user':
            this.resetError = 'E-naslov ni pravilen';
            break;

          case 'Error sending email':
            this.resetError = 'Napaka pri pošiljanju e-pošte';
            break;
          default:
            this.resetError = 'Napaka pri ponastavitvi gesla';
            break;
        }
      } else {
        this.resetSuccess = true;
      }
    }, (error) => {
      this.resetProgress = false;
      this.resetSuccess = false;
      this.resetError = 'Napaka pri ponastavitvi gesla';
    });
  }

}
